import ReactDOM from 'react-dom';
import { UiIcon } from 'znanie-uikit';
import { useRouter } from 'next/router';

import css from './SearchMobile.module.scss';

export default function SearchMobile() {
  const router = useRouter();

  return ReactDOM.createPortal(
    <div className={css.block} onClick={() => router.push('/search')}>
      <UiIcon name="search" size={24} />
    </div>,
    document.getElementById('znanie-header_before-user') as HTMLDivElement
  );
}
